<template>
  <div>
    <el-header class="header" height="40px">
      <!-- <div class="login">管理后台登录</div> 
      <div class="divider">|</div>-->
      <!-- 语言下拉框 -->
      <div class="language-select">
        <el-select
          v-model="selectedLang"
          placeholder="语言"
          size="mini"
          class="lang-selector"
          @change="handleLangChange"
        >
          <el-option
            v-for="lang in langOptions"
            :key="lang.value"
            :label="lang.label"
            :value="lang.value"
          ></el-option>
        </el-select>
      </div>
    </el-header>
  </div>
</template>

<script>
export default {
  data() {
    return {
      selectedLang: this.$i18n.locale,
      // 语言选项（可根据需求扩展）
      langOptions: [
        { value: "zh", label: "简体中文" },
        { value: "en-us", label: "English" },
        { value: "zh-hk", label: "繁体中文" },
      ],
    };
  },
  mounted() {
    // 第二步：若需要强制刷新后重置为简体，可额外清除本地存储（可选）
    // localStorage.removeItem('lang');
    // 兜底：确保mounted时仍同步i18n语言
    this.selectedLang = this.$i18n.locale;
  },
  watch: {
    "$i18n.locale"(newLang) {
      this.selectedLang = newLang;
    },
  },
  methods: {
    handleLangChange(lang) {
      // 1. 更新i18n当前语言
      this.$i18n.locale = lang;
      // 2. 保存到本地存储，刷新后保留选择
      localStorage.setItem("lang", lang);
      // 3. 同步更新浏览器标签页标题（根据当前路由的titleKey）
      if (this.$route.meta.titleKey) {
        document.title = this.$i18n.t(this.$route.meta.titleKey);
      }
    },
  },
};
</script>

<style scoped>
.header {
  background-color: #c6a658;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding-right: 80px;
}
.login {
  color: white;
}

/* 分隔线样式 */
.divider {
  color: rgba(255, 255, 255, 0.7); /* 半透明白色，避免生硬 */
  margin: 0 12px; /* 左右间距，分隔元素 */
  font-size: 16px;
}

/* 语言下拉框容器 */
.language-select {
  max-width: 80px;
  display: flex;
  align-items: center;
}

/* 下拉框触发区样式 */
::v-deep .lang-selector {
  /* 触发区文字颜色 */
  color: white;
  font-size: 24px;
}

/* 下拉框输入框（触发区）样式 */
::v-deep .lang-selector .el-input__inner {
  background: transparent; /* 透明背景，融入头部 */
  border: none; /* 去掉边框 */
  color: white; /* 文字白色 */
  padding: 0px; /* 给箭头留空间 */
  cursor: pointer; /* 鼠标悬停显示手型 */
}

/* 下拉框箭头图标样式 */
::v-deep .lang-selector .el-input__suffix-inner .el-select__caret {
  color: white; /* 箭头白色，与文字统一 */
}

/* 下拉选项悬停样式 */
::v-deep .el-select-dropdown__item:hover {
  background-color: #f5f3e6; /* 浅金色背景，呼应头部 */
  color: #c6a658;
}

/* 下拉选项选中样式 */
::v-deep .el-select-dropdown__item.selected {
  color: #c6a658;
  font-weight: 500;
}
</style>
